'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _browserProcessHrtime = require('browser-process-hrtime');

var _browserProcessHrtime2 = _interopRequireDefault(_browserProcessHrtime);

exports['default'] = _browserProcessHrtime2['default'];
module.exports = exports['default'];
//# sourceMappingURL=hrtime-browser.js.map